<div [ngClass]="_containerClass">
    <div [class]="clearable && (value || hasError) ? 'input-group' : ''">
        <label [ngClass]="_inputClass">
            <input
                *ngIf="isImage"
                (ngModelChange)="filename = $event"
                (change)="onChange($event)"
                type="file"
                accept="image/*"
                class="emma-input-file-image__input"
                [required]="!!required"
                [readonly]="readonly"
                [disabled]="disabled"
            />
            <input
                *ngIf="!isImage"
                (ngModelChange)="filename = $event"
                (change)="onChange($event)"
                type="file"
                [accept]="accept"
                class="emma-input-file-content__input"
                [required]="!!required"
                [readonly]="readonly"
                [disabled]="disabled"
            />
            <ng-container [ngSwitch]="hasError">
                <ng-container *ngSwitchCase="true">
                    {{ fileErrorText }}
                </ng-container>
                <ng-container *ngSwitchDefault [ngSwitch]="loading">
                    <ng-container *ngSwitchCase="false">
                        <ng-container *ngIf="file">
                            {{ file?.name }}
                        </ng-container>
                        <ng-container *ngIf="!file">
                            <ng-container *ngIf="value">
                                {{ placeholderChange }}
                            </ng-container>
                            <ng-container *ngIf="!value">
                                {{ placeholder }}
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ fileLoadingText }}
                    </ng-container>
                </ng-container>
            </ng-container>
        </label>
        <ng-container *ngIf="!readonly && !disabled && clearable && (value || hasError)">
            <button (click)="onClear()" class="btn btn-metal m-btn--icon" type="button">
                <span class="m--font-danger">
                    <i class="la la-trash" aria-hidden="true"></i>
                    <span i18n>Eliminar</span>
                </span>
            </button>
        </ng-container>
    </div>
    <div *ngIf="isImage && (value || previewUrl)" class="emma-input-file-image__preview">
        <img [src]="value || previewUrl" alt="Preview" />
    </div>
</div>
